import { gql } from 'apollo-angular';

export const GET_SETTINGS = gql`
  query Settings {
    Settings {
      id
      companyName
      companyAddressLine1
      companyAddressLine2
      companyNif
      companyPhone
      resendApiKey
      defaultInternalEmail
      insurancePercentage
      customsPercentage
      updatedAt
    }
  }
`;

export const UPDATE_SETTINGS = gql`
  mutation SettingsUpdate($data: SettingsUpdateInput!) {
    SettingsUpdate(data: $data) {
      id
      companyName
      companyAddressLine1
      companyAddressLine2
      companyNif
      companyPhone
      resendApiKey
      defaultInternalEmail
      insurancePercentage
      customsPercentage
      updatedAt
    }
  }
`;

// Authenticated-only, no admin gate — safe to call from the send-proposal
// dialog for any proposal sender, unlike GET_SETTINGS above (admin-only,
// also returns the plaintext Resend key).
export const GET_SETTINGS_DEFAULT_INTERNAL_EMAIL = gql`
  query SettingsDefaultInternalEmail {
    SettingsDefaultInternalEmail
  }
`;

// Authenticated-only, no admin gate — safe to call from the add-cost dialog
// for any proposal user, unlike GET_SETTINGS above (admin-only, also returns
// the plaintext Resend key).
export const GET_SETTINGS_COST_PERCENTAGES = gql`
  query SettingsCostPercentages {
    SettingsCostPercentages {
      insurancePercentage
      customsPercentage
    }
  }
`;

export const GET_SETTINGS_TRUNCATE_COUNTS = gql`
  query SettingsTruncateCounts($entity: DataTruncateEntity!) {
    SettingsTruncateCounts(entity: $entity) {
      table
      count
    }
  }
`;

export const SETTINGS_TRUNCATE = gql`
  mutation SettingsTruncate($entity: DataTruncateEntity!) {
    SettingsTruncate(entity: $entity) {
      table
      count
    }
  }
`;
